{
  "c-corporation": "C Corporation",
  "partnership": "Partnership",
  "s-corporation": "S Corporation",
  "sole-proprietorship": "Sole Proprietorship"
}
